module.exports = __webpack_public_path__ + "img/yijia2.4fc362dc.jpg";